
import { MapLocation } from '@/types/location';

// Aura Centers Gym Locations
export const auraCentersGyms: MapLocation[] = [
  {
    id: 6001,
    name: "Aura Centers - Jeddah (Ash Shati)",
    type: "Gym",
    devices: 8,
    coordinates: [21.58260151232292, 39.11024044534295],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-44",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 6002,
    name: "Aura Centers - Jeddah (Prince Naif)",
    type: "Gym",
    devices: 3,
    coordinates: [21.771829553767827, 39.09842449510017],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  }
];
